const baseUrl = process.env.REACT_APP_GORRILA_API;

//Authentication
const login = baseUrl + "/auth";
const logout = baseUrl + "/auth";
const checkOtp = baseUrl + "/auth/check-otp";
const forgotPassword = baseUrl + "/auth/forgot-password";
const registerANewUser = baseUrl + "/auth/register";
const resendOtp = baseUrl + "/auth/resend-otp";
const resetPassword = baseUrl + "/auth/reset-password";
const getStatus = baseUrl + "/auth/status";
const socialAuthGoogle = baseUrl + "/auth/google";
const socialAuthApple = baseUrl + "/auth/apple";
const Authentication = {
  login,
  logout,
  checkOtp,
  forgotPassword,
  registerANewUser,
  resendOtp,
  resetPassword,
  getStatus,
  socialAuthGoogle,
  socialAuthApple,
};

//Me
const getUserInformation = baseUrl + "/me";
const getPeopleYouMightKnow = baseUrl + "/me/discover";
const getYourInnerCircle = baseUrl + "/me/inner-circle";
const getRecommendedJobs = baseUrl + "/me/jobs";
const getMentions = baseUrl + "/me/mentions";
const getSuggestedUsers = baseUrl + "/me/suggested";
const getAllUsers = baseUrl + "/me/users";
const me = {
  getUserInformation,
  getPeopleYouMightKnow,
  getYourInnerCircle,
  getRecommendedJobs,
  getMentions,
  getSuggestedUsers,
  getAllUsers,
};

//Connections
const getConnections = baseUrl + "/connections";
const followAUser = baseUrl + "/follow";
const unfollowAUser = baseUrl + "/follow";
const getFollowCounts = baseUrl + "/follow/counts";
const getFollowersUsers = baseUrl + "/follow/followers";
const getFollowingUsers = baseUrl + "/follow/following";
const removeAFollower = baseUrl + "/follow/remove";
const searchUsers = baseUrl + "/follow/search";
const connections = {
  getConnections,
  followAUser,
  getFollowCounts,
  getFollowersUsers,
  getFollowingUsers,
  unfollowAUser,
  removeAFollower,
  searchUsers,
};

//Saved Items
const getSavedItemsCounts = baseUrl + "/saved_items";
const createSavedItem = baseUrl + "/saved_items";
const deleteSavedItem = baseUrl + "/saved_items";
const savedItems = {
  getSavedItemsCounts,
  createSavedItem,
  deleteSavedItem,
};

//posts
const post = baseUrl + "/posts/";
const userPosts = baseUrl + "/user/posts/";
const repostAPost = baseUrl + "/posts/repost";
const createPostDraft = baseUrl + "/posts/draft";
const activateAPost = baseUrl + "/posts/activate";
const getPostImage = baseUrl + "/images/posts/";
const rateInteractions = baseUrl + "/rate_interactions";
const getPostMetadata = baseUrl + "/post-meta/";

const posts = {
  post,
  userPosts,
  repostAPost,
  createPostDraft,
  activateAPost,
  getPostImage,
  rateInteractions,
  getPostMetadata,
};

//Onboarding
const getGeoLocationData = baseUrl + "/location/geolocation";
const queryCityByUserInput = baseUrl + "/location/query-city";
const saveCityLocation = baseUrl + "/location/save-city";

const getUserIndustries = baseUrl + "/industries/user_industries";
const searchIndustries = baseUrl + "/industries/search";
const addUserIndustries = baseUrl + "/industries/add";

const getUserInterests = baseUrl + "/interests/user_interests";
const searchInterests = baseUrl + "/interests/search";
const addUserInterests = baseUrl + "/interests/add";

const getUserJobTitles = baseUrl + "/job-titles/titles";
const searchJobTitles = baseUrl + "/job-titles/search";
const addUserJobTitles = baseUrl + "/job-titles/add";

const getUserProfile = baseUrl + "/profile/user";

const onboarding = {
  getGeoLocationData,
  queryCityByUserInput,
  saveCityLocation,

  getUserIndustries,
  searchIndustries,
  addUserIndustries,

  getUserInterests,
  searchInterests,
  addUserInterests,

  getUserJobTitles,
  searchJobTitles,
  addUserJobTitles,

  getUserProfile,
};

//NLP - AI Recommendations
const getModelUsers = baseUrl + "/nlp/recommended-users";

const nlp = { getModelUsers };

//polls
const CreateANewPoll = baseUrl + "/polls";
const poll = baseUrl + "/polls";

const polls = { CreateANewPoll, poll };

//comment
const comments = baseUrl + "/comments/";

const comment = {
  comments,
};

//newsfeed
const getNewsFeedPosts = baseUrl + "/news-feed/";

const newsfeed = {
  getNewsFeedPosts,
};
//Info
const getEntityInfo = baseUrl + "/info/";

const info = { getEntityInfo };

//postLikes
const dislikeAPost = baseUrl + "/dislikes";
const likeAPost = baseUrl + "/likes";
const getLikesAndDislikesCountForAPost = baseUrl + "/likes";
const removeLikeOrDislikeForAPost = baseUrl + "/likes";

const postLikes = {
  likeAPost,
  dislikeAPost,
  getLikesAndDislikesCountForAPost,
  removeLikeOrDislikeForAPost,
};

//post reactions
const addAReactionToAPost = baseUrl + "/posts";
const getTotalReactionsForAPost = baseUrl + "/posts";
const updateAReactionToAPost = baseUrl + "/posts";
const removeAReactionFromAPost = baseUrl + "/posts";
const getSystemCuratedReactionTypes =
  baseUrl + "/reaction_types/system_curated";

const postReactions = {
  addAReactionToAPost,
  getTotalReactionsForAPost,
  updateAReactionToAPost,
  removeAReactionFromAPost,
  getSystemCuratedReactionTypes,
};

//circle
const circles = baseUrl + "/circles/";

const circle = {
  circles,
};

//postVideo
const getPostVideo = post + "video/";

const postVideo = {
  getPostVideo,
};

//postAudio
const getPostAudio = post + "audio/";
const audioBackgroundImage = baseUrl + "/images/posts/";

const postAudio = {
  getPostAudio,
  audioBackgroundImage,
};

//postGIF
const getPostGIF = post + "gifs/";

const postGIF = {
  getPostGIF,
};

//global
const searchCollaborators = baseUrl + "/global/collaborators";
const anonymous_persona = baseUrl + "/global/anon-user/image/";

const global = {
  searchCollaborators,
  anonymous_persona,
};

//article
const articles = baseUrl + "/articles";
const articleDraft = baseUrl + "/articles/draft";
const articleDrafts = baseUrl + "/articles/drafts";
const articlePublished = baseUrl + "/articles/published";
const articleScheduled = baseUrl + "/articles/scheduled";
const articleManage = baseUrl + "/articles/manage";
const articleImages = baseUrl + "/articles/images/";
const articleContent = baseUrl + "/articles/content";
const articlesAudio = baseUrl + "/articles/audio";
const articlesVideo = baseUrl + "/articles/video";

const article = {
  articles,
  articleDraft,
  articleDrafts,
  articleContent,
  articlesAudio,
  articlesVideo,
  articlePublished,
  articleScheduled,
  articleManage,
  articleImages,
};

export const API_PATHS = {
  Authentication,
  me,
  connections,
  savedItems,
  posts,
  onboarding,
  nlp,
  polls,
  comment,
  newsfeed,
  info,
  postLikes,
  postReactions,
  circle,
  postVideo,
  postAudio,
  postGIF,
  global,
  article,
};
